import { createSvgIcon } from '@mui/material/utils';

const BrandIcon = createSvgIcon(
  <g
    transform="translate(12,12) scale(1.2) translate(-13.25,-11.55)"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.6}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7.5,18.5 V11 Q7.5,7.8 11,7.8 H19" />
    <path d="M14.5,4.6 V15.2 Q14.5,18.5 17.8,18.5" />
  </g>,
  'BrandIcon'
);

export default BrandIcon;
